import React from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";

import config from "../constants/config";
import { logout } from "../actions/auth";

const cookies = new Cookies();
const styles = {
  logoutButton: {
    height: "fit-content",
    padding: "9px 20px",
    border: "1px solid grey",
    borderRadius: 50,
    alignSelf: "center",
    backgroundColor: "transparent",
    outline: "none"
  },
  editButton: {
    color: "white",
    backgroundColor: "#828282",
    border: "none",
    outline: "none",
    padding: "4px 20px",
    borderRadius: 50,
    fontSize: "0.6rem",
    marginTop: 15
  },
  pageHeader: {
    fontWeight: "500",
    margin: "0.3em 0"
  },
  subHeader: {
    marginBottom: 5,
    color: "#828282"
  }
};

class Account extends React.Component {
  logout = () => {
    fetch(`${config.API_ENDPOINT}/logout`).then(() => {
      cookies.remove(config.JWT_COOKIE);
      this.props.logout();
      this.props.history.push("/");
    });
  };

  render() {
    const { email, phone } = this.props.userData.account || {};

    return (
      <div style={{ flex: 1, overflow: "auto", padding: 30 }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <h2 style={styles.pageHeader}>Profile</h2>
          <button style={styles.logoutButton} onClick={this.logout}>
            LOGOUT
          </button>
        </div>

        <div style={{ width: "100%" }}>
          <h5 style={styles.subHeader}>Email</h5>
          <span>{email}</span>
        </div>

        <div style={{ width: "100%" }}>
          <h5 style={styles.subHeader}>Phone</h5>
          <span>{phone || "not set"}</span>
        </div>

        {this.props.userData.LoginType === "local" && (
          <div style={{ width: "100%" }}>
            <h5 style={styles.subHeader}>Password</h5>
            <span style={{ display: "block" }}>********</span>
            <button style={styles.editButton}>Edit</button>
          </div>
        )}

        <h2 style={{ ...styles.pageHeader, marginTop: "1.2em" }}>Billing</h2>
        <div style={{ width: "100%" }}>
          <h5 style={styles.subHeader}>Payment Method</h5>
          <img
            src={require("../assets/demo/sample-bank.png")}
            alt="checkout"
            style={{ width: "100%" }}
          />
          <span style={{ display: "block", fontSize: "0.8rem" }}>
            Your plan will automatically renew on <b>3/12/2019</b> and you will
            be charged <b>$4.99</b>
          </span>
          <button style={styles.editButton}>Update</button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout())
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Account);
